<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>

    <tt-card>
        <tt-date ttLabel="start_date" [(ttModel)]="setting.start_date" (ttModelChange)="onChanged($event, 'start_date')"></tt-date>
    </tt-card>

    <tt-list-legacy [listItems]="itemsListNewActs" ltype="custom" [designVar]="'s12t0'" [optionfunc]="toggleChosen.bind(this)"></tt-list-legacy>

    <tt-card [hidden]="itemsListNewActs.length === 0">
        <tt-button-save ttText="serviceobjectnewact_create" (ttClick)="createChanges()" [ttLoading]="creating"></tt-button-save>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <div ng-if="vm.model.setting.page_heading > ''">
        <tt-header tt-model="vm.model.setting.page_heading"></tt-header>
    </div>

    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-datetime class="col-xs-12 sp-0" tt-label="start_date" tt-model="vm.model.setting.start_date" tt-change="vm.onChanged($value, 'start_date')" tt-date-options="{ date: {show: true, disabled: false, align: 'right'}, hour: {show: false, disabled: false, align: 'right'}, minute: {show: false, disabled: false, align: 'right', interval: 1}}"></tt-datetime>
    </tt-card>

    <tt-list class="col-xs-12 col-md-4 sp-0" list-items="vm.model.itemsListNewActs" badge="" ltype="custom" design-var="s12t0" optionfunc="vm.toggleChosen(item)"></tt-list>

    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-button-save class="col-xs-12 sp-0" tt-text="serviceobjectnewact_create" tt-locked="vm.model.lockedSave" tt-click="vm.setMarkedAs()" tt-text-align="center"></tt-button-save>
    </tt-card>
</tt-page>-->
